import MediaUploadElement from 'admin/editor/components/media_upload';
import UserMediaUploadElement from 'admin/editor/components/user_media_upload';
import MediaUrlElement from 'admin/editor/components/media_url';

export default class MediaElement {
  constructor(options) {
    this.learnEditor = options.editor;
    this.mediaUploadElement = new MediaUploadElement({editor: this.learnEditor});
    this.userMediaUploadElement = new UserMediaUploadElement({editor: this.learnEditor});
    this.MediaUrlElement = new MediaUrlElement({editor: this.learnEditor});

    this.elements = [
      this.MediaUrlElement,
      this.mediaUploadElement,
      this.userMediaUploadElement
    ]

    const action = (navigator.userAgent.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on('click', '.add-build-media', this.newElement.bind(this));
    $(document).on('click', '.add-build-media-cancel', this.backToAllElements.bind(this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-media" href="#"><i class="fa fa-picture-o"></i>Media</a>';
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    link.closest('.bottom-button-bar, .button-bar').html(this.chooseMediaTemplate());

    this.learnEditor.$element.trigger('editor-loaded');

  }

  backToAllElements(event) {
    event.preventDefault();

    $('.bottom-button-bar').remove();
    this.learnEditor.finishEditing();
  }

  chooseMediaTemplate() {
    var $template =  $(`
      <div>
        <div class="title-text">Choose a type of media</div>
        <div class="buttons">
          <a class="add-build-media-cancel" href="#"><i class="fa fa-arrow-left"></i>Back to All Elements</a>
          <div class="clearfix"></div>
        </div>
      </div>`)

    this.elements.forEach(element => {
      if (element.shouldShowButton()) {
        $template.find('.buttons').prepend(element.addButtonTemplate());
      }
    });

    return $template;
  }
}
